module.exports = __webpack_public_path__ + "static/media/testimonial3.a8d9651e.jpeg";